<template>
  <modal @before-open="beforeOpen" @opened="opened" name="sysNavSort" :draggable="'.header'" :reset="true"
         :classes="['sysNavSort','generalbox']" :adaptive="true"
         :scrollable="true" :height="'80%'" :width="'80%'" :max-width="1540" :max-height="885" :min-width="1092"
         :min-height="614" :click-to-close="false">
    <div @click="close" class="close">
      <i class="iconfont icon-cha"></i>
    </div>
    <div class="header">
      <h2>应用系统排序</h2>
    </div>
    <div class="content">
      <div class="sortPageContainer">
        <iframe class="sortPage" :src="sortPageURL" frameborder="0"></iframe>
      </div>
    </div>
  </modal>
</template>

<script>
  import axios from 'axios';
  import apiConfig from 'common/js/api_config'
  import Bus from 'common/js/bus.js'
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex'

  export default {
    name: "sysNavSort",
    data() {
      return {}
    },
    methods: {
      ...mapMutations(['updateModalZIndex']),
      close() {
        Bus.$emit('refreshSysNavList')
        this.$modal.hide("sysNavSort");
      },
      beforeOpen() {

      },
      opened(){
        this.updateModalZIndex(this.$el)
      }
    },
    computed: {
      sortPageURL() {
        return apiConfig.REQUEST_URL + '/shall/manage/btrain_user.jsp'
      }
    },
    mounted() {
    },
    components: {}
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .content
    overflow hidden
    .sortPageContainer
      width 100%
      height 100%
      .sortPage
        width 100%
        height 100%
</style>



// WEBPACK FOOTER //
// src/components/personal/sysNavSort.vue